import HarmonizeLightLogo from "../assets/images/LBMC_Harmonize_LightMode_Logo.svg";
import HarmonizeDarkLogo from "../assets/images/LBMC_Harmonize_DarkMode_Logo.svg";
import openFolderIcon from "../assets/images/Open_folder.svg";
import openFolderIconDark from "../assets/images/Open_folder_Dark.svg";
import StarFilledIconSidebar from "../assets/images/StarFilled_LSB.svg";
import StarFilledIconSidebarDark from "../assets/images/StarFilled_Dark.svg";
import HelpIcon from "../assets/images/Help_icon.svg";
import HelpIconDark from "../assets/images/help_icon_dark.svg";
import DarkModeMoon from "../assets/images/Dark_mode_Moon.svg";
import DarkModeSun from "../assets/images/Sun_icon_dark.svg";
import LightModeSunicon from "../assets/images/Sun_icon_dark.svg";
import StaroutlineIcon from "../assets/images/StarOutline_LSB.svg";
import StaroutlineIconDark from "../assets/images/StarOutline_Dark.svg";
import LogoutIcon from "../assets/images/Logout.svg";
import LogoutIconDark from "../assets/images/DarkLogOut.svg";
import closeFolderIcon from "../assets/images/Closed_folder.svg";
import closeFolderIconDark from "../assets/images/Closed_folder_Dark.svg";
import ShareFavIcon from "../assets/images/ShareFav.svg";
import ShareFavIconDark from "../assets/images/ShareFav_Dark.svg";
import FollowIcon from "../assets/images/CheckmarkCircle.svg";
import FollowIconDark from "../assets/images/CheckmarkCircle_Dark.svg";
import CopyIcon from "../assets/images/Copy.svg";
import ActualsEllipseIcon from "../assets/images/ActualsEllipse.svg";
import BudgetEllipseIcon from "../assets/images/BudgetEllipse.svg";
import FollowingIcon from "../assets/images/Add_circle.svg";
import FollowingIconDark from "../assets/images/Add_circle_Dark.svg";
import DashboardfavIcon from "../assets/images/plus-circle.svg";
import DashboardfavIconDark from "../assets/images/plus-circle-dark.svg";
import HomeIcon from "../assets/images/Home.svg";
import HomeIconDark from "../assets/images/Home_icon_dark.svg";
import SearchIcon from "../assets/images/Search.svg";
import SearchIconDark from "../assets/images/Search_icon_dark.svg";
import EllipsisIcon from "../assets/images/Ellipsis_vertical.svg";
import RequestListIcon from "../assets/images/ic_fluent_person_add_24_regular.svg";
import RequestListIconDark from "../assets/images/ic_fluent_person_add_24_regular_Dark.svg";
import ViewRequestsicon from "../assets/images/ic_fluent_task_list_ltr_24_regular.svg";
import ViewRequestsiconDark from "../assets/images/ic_fluent_task_list_ltr_24_regular_Dark.svg";
import ClockIcon from "../assets/images/Clock.svg";
import ClockIconDark from "../assets/images/Clock_Dark.svg";
import { useTheme } from "../ThemeContext/ThemeContext.tsx";
import NewWindowIcon from "../assets/images/Window New.svg";
import NewChatIcon from "../assets/images/New_chat.svg";
import AdminIcon from "../assets/images/Admin_gear.svg";
import AdminIconDark from "../assets/images/Admin_gear_Dark.svg";

const ICONS = () => {
  const { isDarkMode } = useTheme();

  const icons = isDarkMode
    ? {
        HarmonizeLogo: HarmonizeDarkLogo,
        openFolderIcon: openFolderIconDark,
        closeFolderIcon: closeFolderIconDark,
        StarFilledIconSidebar: StarFilledIconSidebarDark,
        HelpIcon: HelpIconDark,
        DarkModeMoon: DarkModeSun,
        LightModeSunicon: LightModeSunicon,
        StaroutlineIcon: StaroutlineIconDark,
        LogoutIcon: LogoutIconDark,
        ShareFavIcon: ShareFavIconDark,
        FollowIcon: FollowIconDark,
        CopyIcon: CopyIcon,
        ActualsEllipseIcon: ActualsEllipseIcon,
        BudgetEllipseIcon: BudgetEllipseIcon,
        FollowingIcon: FollowingIconDark,
        DashboardfavIcon: DashboardfavIconDark,
        HomeIcon: HomeIconDark,
        SearchIcon: SearchIconDark,
        EllipsisIcon: EllipsisIcon,
        NewWindowIcon: NewWindowIcon,
        RequestListIcon: RequestListIconDark,
        ViewRequestsicon: ViewRequestsiconDark,
        ClockIcon: ClockIconDark,
        NewChatIcon: NewChatIcon,
        AdminIcon: AdminIconDark
      }
    : {
        HarmonizeLogo: HarmonizeLightLogo,
        openFolderIcon: openFolderIcon,
        closeFolderIcon: closeFolderIcon,
        StarFilledIconSidebar: StarFilledIconSidebar,
        HelpIcon: HelpIcon,
        DarkModeMoon: DarkModeMoon,
        LightModeSunicon: LightModeSunicon,
        StaroutlineIcon: StaroutlineIcon,
        LogoutIcon: LogoutIcon,
        ShareFavIcon: ShareFavIcon,
        FollowIcon: FollowIcon,
        CopyIcon: CopyIcon,
        ActualsEllipseIcon: ActualsEllipseIcon,
        BudgetEllipseIcon: BudgetEllipseIcon,
        FollowingIcon: FollowingIcon,
        DashboardfavIcon: DashboardfavIcon,
        HomeIcon: HomeIcon,
        SearchIcon: SearchIcon,
        EllipsisIcon: EllipsisIcon,
        NewWindowIcon: NewWindowIcon,
        RequestListIcon: RequestListIcon,
        ViewRequestsicon: ViewRequestsicon,
        ClockIcon: ClockIcon,
        NewChatIcon: NewChatIcon,
        AdminIcon: AdminIcon
      };

  return icons;
};
export default ICONS;
